import React, { useCallback } from 'react';
import { StyledNumericInput } from '../StyledComponent';

const PhoneInput = React.forwardRef(({ value, onChange: inputOnChange, className, ...rest }, ref) => {
  const onChange = useCallback(
    (e) => {
      inputOnChange(e.floatValue || null);
    },
    [inputOnChange],
  );

  return (
    <StyledNumericInput
      getInputRef={ref}
      decimalScale={0}
      value={value ?? ''}
      onValueChange={onChange}
      type="text"
      dir="ltr"
      className={className}
      {...rest}
    />
  );
});

export default React.memo(PhoneInput);
